import { render, staticRenderFns } from "./SectionToggle.vue?vue&type=template&id=242f144c&"
import script from "./SectionToggle.vue?vue&type=script&lang=js&"
export * from "./SectionToggle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports